__turbopack_context__.v({
  "background": "VGy87W_background",
  "background__mobile": "VGy87W_background__mobile",
  "button": "VGy87W_button",
  "card": "VGy87W_card",
  "card--placeholder": "VGy87W_card--placeholder",
  "content": "VGy87W_content",
  "content__image": "VGy87W_content__image",
  "content__information": "VGy87W_content__information",
  "content__text": "VGy87W_content__text",
  "date": "VGy87W_date",
  "date__live": "VGy87W_date__live",
  "date__soon": "VGy87W_date__soon",
  "date__today": "VGy87W_date__today",
  "description": "VGy87W_description",
  "event": "VGy87W_event",
  "shimmer": "VGy87W_shimmer",
  "text-bar-sweep": "VGy87W_text-bar-sweep",
  "title": "VGy87W_title",
});
